<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="mian_view">
      <div class="mian">
        <div class="mian_left">
          <div class="perm_btn">
            <p>权限管理：</p>
            <p>
              (姓名:{{ $parent.currentRow.RealName }} 账号:{{
                $parent.currentRow.username
              }})
            </p>
          </div>

          <div class="perm_btn">
            <p>题库管理：</p>
            <!-- <p>当前可以使用等共个题库</p> -->
            <p>当前可以使用{{ AppNameText }}等{{ CountNum }}个题库</p>
          </div>
          <el-button @click="addtestcope">配置题库</el-button>
          <!-- <div class="perm_btn">
            <p>菜单权限：</p>
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                label="复选框 A"
                @change="foldingCheked()"
                :checked="fang"
                >展开/折叠</el-checkbox
              >
              <el-checkbox
                label="复选框 B"
                @change="resetChecked()"
                :checked="select"
                >全选/全不选</el-checkbox
              >
              <el-checkbox label="复选框 C" @change="linkage"
                >父子联动</el-checkbox
              >
            </el-checkbox-group>
          </div> -->
          <div class="check_card show">
            <p>菜单权限</p>
            <div>
              <el-tree
                :data="data"
                show-checkbox
                default-expand-all
                node-key="id"
                ref="tree"
                highlight-current
                :props="props"
                :check-strictly="Father"
              >
              </el-tree>
            </div>
          </div>
        </div>
        <div class="mian_right">
          <div class="perm_btn">
            <p>科室管理权限:</p>
            <el-checkbox-group v-model="checkList1">
              <el-checkbox
                label="复选框 A"
                @change="department()"
                :checked="fang1"
                >展开/折叠</el-checkbox
              >
              <el-checkbox
                label="复选框 B"
                @change="departmentChecked()"
                :checked="select1"
                >全选/全不选</el-checkbox
              >
              <!-- <el-checkbox label="复选框 C" @change="departmentLinkage"
                >父子联动</el-checkbox
              > -->
            </el-checkbox-group>
          </div>
          <div class="check_card check_card_rigght">
            <p>科室管理权限</p>
            <div>
              <el-tree
                :data="dataguanlikeshi"
                show-checkbox
                default-expand-all
                node-key="DepartmentID"
                ref="guanlitree"
                highlight-current
                :props="guanliprops"
                :check-strictly="Father1"
              >
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <!-- 考试弹框 -->
      <testdialog ref="testdialog"></testdialog>
      <!-- 按钮 -->
      <div class="save_btn">
        <el-button @click="cancel">返回</el-button>
        <el-button @click="save">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import testdialog from "../components/testcopedialog.vue";
import loginvuex from "@/store/index";
import {
  authAppSelect,
  userauthlist,
  listResourceTree,
  getUserResource,
  updateUserResource,
  authAppAll,
  saveuserauth,
} from "@/api/permissions.js";
export default {
  data() {
    return {
      checkList: [],
      checkList1: [],
      fang: true, // 判断是否展开或则折叠状态 ===> 菜单权限
      fang1: true, // 判断是否展开或则折叠状态 ===> 科室权限
      select: false, // 判断是否全选择 ===> 菜单权限
      select1: true, // 判断是否展开或则折叠状态 ===> 科室权限
      Father: false, // 判断是否父子联动 默认进来联动 ===> 菜单权限
      Father1: false, // 判断是否父子联动 默认进来联动 ===> 科室权限
      CountNum: "", // 题库的数量
      AppNameText: "", // 题集
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1",
            },
            {
              id: 6,
              label: "二级 2-2",
            },
          ],
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      isdefaultdata: [], //默认选中的值
      props: {
        children: "children",
        label: "name",
        value: "id",
      },
      guanliprops: {
        children: "children",
        label: "DepartmentName",
      },

      dataguanlikeshi: [], //科室管理的数据
    };
  },
  props: ["cutcoms"],
  components: {
    testdialog,
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    fn() {
      console.log("复选框 A");
    },
    //打开题库的弹窗
    async addtestcope() {
      let resa = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        studentUserID: this.$parent.currentRow.userid,
      };
      let testiddata = await authAppAll(resa);
      testiddata = testiddata.data.Data.map((item) => {
        return item.AppID;
      });
      console.log(testiddata);
      // this.$refs.testdialog.props.value = "id"
      //这里回显的ID有问题
      this.$refs.testdialog.val = testiddata;
      this.$refs.testdialog.dialogVisible = true;
      // this.$refs.testdialog.isdialogVisible = 1;
      this.$refs.testdialog.settestscope();
    },
    // 是否展开折叠 ==> 菜单权限
    foldingCheked() {
      if (this.fang == false) {
        this.fang = true; // 选中的时候全部展开
        for (let i = 0; i < this.data.length; i++) {
          this.$refs.tree.store.nodesMap[this.data[i].AuthID].expanded = true;
        }
        console.log(this.$refs.tree.store.nodesMap);
      } else {
        this.fang = false;
        for (let i = 0; i < this.data.length; i++) {
          this.$refs.tree.store.nodesMap[this.data[i].AuthID].expanded = false;
          // console.log(this.$refs.tree.data[i].id);
        }
      }
      console.log(this.data, "=====>菜单");
      console.log(this.$refs.tree.store.nodesMap, "菜单");
    },
    // 是否展开折叠 ==> 科室权限
    department() {
      if (this.fang1 == false) {
        this.fang1 = true; // 选中的时候全部展开
        for (let i = 0; i < this.dataguanlikeshi.length; i++) {
          this.$refs.guanlitree.store.nodesMap[
            this.dataguanlikeshi[i].DepartmentID
          ].expanded = true;
        }
        console.log(this.$refs.guanlitree.store.nodesMap);
      } else if (this.fang1 == true) {
        this.fang1 = false;
        for (let i = 0; i < this.dataguanlikeshi.length; i++) {
          this.$refs.guanlitree.store.nodesMap[
            this.dataguanlikeshi[i].DepartmentID
          ].expanded = false;
          // console.log(this.$refs.tree.data[i].id);
        }
      }
      console.log(this.dataguanlikeshi, "=====>科室");
      console.log(this.$refs.guanlitree.store.nodesMap, "科室管理");
    },
    // 全选清空选择 ===> 菜单权限
    resetChecked() {
      if (this.select == false) {
        this.select = true; // 全部选择
        this.$refs.tree.setCheckedNodes(this.data);
      } else {
        this.select = false; // 取消全部选择
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    // 全选清空选择  ===> 科室管理
    departmentChecked() {
      if (this.select1 == false) {
        this.select1 = true; // 全部选择
        this.$refs.guanlitree.setCheckedNodes(this.dataguanlikeshi);
      } else {
        this.select1 = false; // 取消全部选择
        this.$refs.guanlitree.setCheckedKeys([]);
      }
    },
    // 是否父子联动关系 ===> 菜单权限
    linkage() {
      if (this.Father == false) {
        this.Father = true; // 为true是不使用父子节点
      } else {
        this.Father = false;
      }
    },
    // 是否父子联动关系 ===> 科室管理
    departmentLinkage() {
      if (this.Father1 == false) {
        this.Father1 = true; // 为true是不使用父子节点
      } else {
        this.Father1 = false;
      }
    },
    // 权限查询
    async getAuthApp() {
      let res = {
        studentUserID: this.$parent.currentRow.userid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await authAppSelect(res);
      console.log(Data.data.Data, "Data.data.Data");
      if (Data.data.Status === 200) {
        if (Data.data.Data.AppNameArr) {
          this.CountNum = Data.data.Data.AppCount;
          let text = Data.data.Data.AppNameArr;
          console.log(text, "???text", Data);
          let a = text.toString();
          this.AppNameText = a.replace(RegExp(",", "g"), "、");
        }
      } else {
        this.$message.error("数据异常");
      }
      console.log(this.AppNameText);
    },
    async setCheckedKeys() {
      //设置默认选中的权限。
      let parmars = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        userId: this.$parent.currentRow.userid,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      let res = await getUserResource(parmars);
      console.log(Object.values(res.data.Data));
      // console.log(JSON.stringify(Object.values(res.data.Data)));
      // let isdefault = this.data.map((item) => {
      //   return item.children.filter((items) => {
      //     return items.Enable == 1;
      //   });
      // });
      let isdefaultkeshi = this.dataguanlikeshi[0].children.filter((item) => {
        return item.Enable == 1;
      });
      // console.log(isdefault.flat(2));
      // console.log(this.$refs.tree.setCheckedNodes);
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(Object.values(res.data.Data).flat(2));
        this.$refs.guanlitree.setCheckedNodes(isdefaultkeshi);
      });
      // this.isdefaultdata = isdefault.flat(2)
    },
    // 权限列表
    async getDatalist() {
      let parmars = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hospital: JSON.parse(loginvuex.state.hid),
        roleCode: "hospital_admin",
        type: "0",
      };
      let resa = await listResourceTree(parmars);
      this.data = resa.data.Data;
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        usb: this.$parent.currentRow.userid,
      };
      const Data = await userauthlist(res);
      //  let newobj = Data.data.Data.Auth; //菜单栏的
      let guanlikeshi = Data.data.Data.Department;
      let guanlikeshiarr = [];
      let paramss = {
        DepartmentID: 101,
        DepartmentName: "管理的科室",
        children: guanlikeshi,
      };
      guanlikeshiarr.push(paramss);
      this.dataguanlikeshi = guanlikeshiarr;
      // for (let key in newobj) {
      //   let parmas = { AuthID: keyid++, AuthName: key, children: newobj[key] };
      //   newarr.push(parmas);
      // }
      // this.data = newarr;
      this.setCheckedKeys();
    },
    //确定保存
    save() {
      let parmas = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        userId: this.$parent.currentRow.userid,
        resourceIds: this.$refs.tree
          .getCheckedKeys(false)
          .concat(this.$refs.tree.getHalfCheckedKeys()),
      };
      updateUserResource(parmas);
      let data = {
        Department: this.$refs.guanlitree.getCheckedKeys(true, false),
        Auth: this.$refs.tree.getCheckedKeys(true, false),
        userID: this.$parent.currentRow.userid,
      };
      data.Auth = data.Auth.length == 0 ? ['1']:data.Auth
      let pasms = {
        data: JSON.stringify(data),
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
      };
      saveuserauth(pasms);
      this.$message.success("修改成功");
      this.dialogVisible = false;
      this.cutcoms(0);
    },
    cancel() {
      this.cutcoms(0);
    },
  },
  created() {
 
  },
  activated(){
   this.getAuthApp();
    this.getDatalist();
  }
};
</script>

<style lang="scss" scoped>
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: #f8f8f8;
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.mian_view {
  background: #ffff;
  height: 100%;
  .save_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
    margin-top: 30px;
    .el-button {
      width: 110px;
      height: 42px;
      &:nth-child(1) {
        background: #eeeeee;
        color: #aaaaaa;
        margin-right: 90px;
      }
      &:nth-child(2) {
        background: #1890ff;
        color: #fff;
      }
    }
  }
}
.mian {
  margin-top: 24px;
  display: flex;
  border-radius: 10px;
  width: 80%;
  height: 100%;
  padding: 20px 24px;
  .mian_left {
    // border: 1px solid #000;
    // width: 564px;
    flex: 1;
    .perm_text {
      height: 40px;
    }
    .el-button {
      width: 92px;
      height: 40px;
      background: #1890ff;
      color: #fff;
      margin: 20px 0px 10px 0px;
    }
    ::v-deep .el-tree {
      max-height: 400px;
      overflow-x: hidden;
      overflow-y: scroll;
      // background-color: red;
    }
  }
  .perm_btn {
    display: flex;
    align-items: center;
    margin-top: 10px;
    p {
      font-size: 16px;
      &:nth-child(1) {
        width: 105px;
      }
    }
  }
  .check_card {
    // min-height: 540px;
    width: 435px;
    border: 1px solid rgba(153, 153, 153, 0.404);
    //   padding: 14px 24px;
    border-radius: 6px;
    margin: 24px 0px 0px 110px;
    padding: 0px 0px 20px 0px;

    p {
      border-radius: 6px;
      height: 45px;
      line-height: 45px;
      background: #ecf6ff;
      padding: 0px 24px;
      font-size: 13px !important;
      font-family: PingFang SC;
      font-weight: bold;
    }
  }
  .mian_right {
    width: 70%;
    flex: 1;
    // min-height: 700px;
    // border: 1px solid red;
    ::v-deep .el-tree {
      max-height: 600px;
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 0px 0px 20px 0px;
      // background-color: red;
    }
  }
}
::-webkit-scrollbar {
  width: 4px !important;
  // height:10px  Im !important;
  background-color: #ddddddf3;
}
::-webkit-scrollbar-thumb {
  background-color: #1890ff;
  border-radius: 50px;
}
.show{
  opacity: 0;
}
</style>